import * as React from "react";
import * as CMP from "../../components";
// imported only for typings
import { BaseDict } from "../../dict";
import { observer } from "mobx-react";
import { RenderMarketsQueryFilter } from "../../data/helpers/RenderMarketsQueryFilter";
import { eBranches } from "sb-resp-lib";

@observer
export class EventCard extends React.Component<{
    event: any,
    handler: Function,
    dict: BaseDict,
    query: object,
    branchMarkets: any,
    isInSlip: Function,
},
{}> {

    renderEventIcons() {
        return (
            <>
                {this.props.event.isLive &&
                    <CMP.EventIcon shouldRender={this.props.event.hasFastMarketsSpecials} modifier="i-24-16 i-o-ev-fast-market"
                    tooltip={this.props.event.hasFastMarketsSpecials ? this.props.dict.FastMarketTooltip : ""} />}
                {!this.props.event.isLive &&
                    <CMP.EventIcon shouldRender={this.props.event.statisticsInfo !== undefined} modifier="i-24-16 i-o-ev-statistics"
                        tooltip={this.props.event.statisticsInfo !== undefined ? this.props.dict.StatisticTooltip : ""}
                        action={this.props.event.statisticsInfoClickHandler} />}
                <CMP.EventIcon shouldRender={this.props.event.hasLiveStream} modifier="i-24-16 i-o-ev-streaming"
                    tooltip={this.props.event.hasLiveStream ? this.props.dict.LiveStreamTooltip : ""} />
            </>);

    }

    renderMarkets() {
        let selectionsHandler = this.props.event.selectionHandler;
        let marketsTrimmed = RenderMarketsQueryFilter(Object.keys(this.props.branchMarkets), this.props.query);
        return (
            marketsTrimmed.map((marketKey, index) => {
                let market = this.props.branchMarkets[marketKey];
                return <CMP.MarketButtons key={`${index}_${this.props.event.id}`} event={this.props.event} market={market} isInSlip={this.props.isInSlip} handler={selectionsHandler} />
            })
        )
    }

    renderScore(index) {
        return (<CMP.TeamScore key={`${this.props.event.id}__${index}`} modifier="rj-sports-multiview__team-score" score={this.props.event[`score${index}`]} />);
    }

    renderTeams() {
        return (this.props.event.isLive && (this.props.event.branchID.toString() === eBranches.Tennis.toString())) ?
            (<CMP.TennisScoreboard tennisData={this.props.event.updatedTennisData} team1Name={this.props.event.team1Name} team2Name={this.props.event.team2Name} />) :
            (<>
                <CMP.Row key={`first-team-${this.props.event.id}`}>
                    {this.props.event.isLive ? this.renderScore(1) : <CMP.EventDate date={this.props.event.eventDate} />}
                    <CMP.TeamName dataUat={"div-multiview-team-0"} key={"first-team-name-" + this.props.event.id} name={this.props.event.team1Name} />
                </CMP.Row>

                <CMP.Row key={`second-team-${this.props.event.id}`}>
                    {this.props.event.isLive ? this.renderScore(2) : <CMP.EventTime time={this.props.event.eventTime} />}
                    <CMP.TeamName dataUat={"div-multiview-team-1"} key={"second-team-name-" + this.props.event.id} name={this.props.event.team2Name} />
                </CMP.Row>
            </>);
    }

    render() {
        const evHandler = this.props.handler.bind(this, this.props.event);
        return (
            <div data-uat="div-multiview-event-card"  className="rj-sports-multiview__event-card">
                <CMP.EventLink href={this.props.event.link} handler={evHandler} dataUat="a-multiview-game-icon" modifier="rj-sports-multiview__event-card-section rj-sports-multiview__game-icon">
                    <div className="rj-sports-multiview__event-section-content">
                        <CMP.GameIcon i={`i-24 i-o-sport-${this.props.event.branchID} event-details-icon-sport event-details-icon-sport-desktop`} />
                        {this.props.event.isLive && <CMP.GameClock time={this.props.event.timeTicking} gameStatus={this.props.event.gameStatus} />}
                    </div>
                </CMP.EventLink>

                <CMP.EventLink href={this.props.event.link} handler={evHandler} dataUat="a-multiview-teams" modifier="rj-sports-multiview__event-card-section rj-sports-multiview__teams-section">
                    <div className="rj-sports-multiview__event-section-content">
                        {this.renderTeams()}
                    </div>
                </CMP.EventLink>

                <CMP.EventLink href={this.props.event.link} handler={evHandler} dataUat="a-multiview-event-icons" modifier="rj-sports-multiview__event-card-section rj-sports-multiview__event-icons">
                    <div className="rj-sports-multiview__event-section-content">
                        {this.renderEventIcons()}
                    </div>
                </CMP.EventLink>

                <div className="rj-sports-multiview__event-card-section rj-sports-multiview__event-markets">
                    <div className="rj-sports-multiview__event-section-content">
                        {this.renderMarkets()}
                    </div>
                </div>

                <CMP.EventLink href={this.props.event.link} handler={evHandler} dataUat="a-multiview-market-counter" modifier="rj-sports-multiview__event-card-section rj-sports-multiview__market_count">
                    <div className="rj-sports-multiview__event-section-content">
                        <span>{this.props.event.allMarketsCount}</span>
                        <span className="rj-sports-multiview__market-count-arrow"></span>
                    </div>
                </CMP.EventLink>
            </div>
        )
    }
}
